<script lang="ts">
  import Angryface from './Smileys/Angryface.svelte';
  import Neutralface from './Smileys/Neutralface.svelte';
  import Pensiveface from './Smileys/Pensiveface.svelte';
  import Smiling from './Smileys/Smiling.svelte';
  import Partyingface from './Smileys/Partyingface.svelte';
  import RadioInput from './RadioInput.svelte';
  import { i18n } from '../../util/i18n/i18n';
  import FeedbackCategory from './FeedbackCategory.svelte';

  export let group: number;
  export let comment = '';
  export let category = '';
  export let onSubmit: () => void;

  const values = [
    {
      emoji: Angryface,
      value: 0,
    },
    {
      emoji: Pensiveface,
      value: 1,
    },
    {
      emoji: Neutralface,
      value: 2,
    },
    {
      emoji: Smiling,
      value: 3,
    },
    {
      emoji: Partyingface,
      value: 4,
    },
  ] as const;
</script>

<form on:submit|preventDefault={onSubmit}>
  <fieldset class="emojiwrapper">
    <legend tabindex="-1">{i18n('feedback.dialog.emoji-header')}</legend>
    {#each values as radioValue}
      <RadioInput
        value={radioValue.value}
        bind:group
        name="feedback-interaction"
        text={i18n(`feedback.dialog.emoji-labels.${radioValue.value}`)}
        selected={radioValue.value === group}
      >
        <svelte:component this={radioValue.emoji} />
      </RadioInput>
    {/each}
  </fieldset>

  <label class="header-style" for="comment">
    {i18n('feedback.dialog.comment-label')}
  </label>
  <textarea
    id="comment"
    name="comment"
    maxlength="1000"
    placeholder={i18n('feedback.dialog.comment-placeholder')}
    class="comment"
    bind:value={comment}
  />

  <FeedbackCategory bind:category />
  <slot />
</form>

<style>
  textarea {
    width: 90%;
    height: 8rem;
    margin: var(--spacing-16);
    padding: var(--spacing-8);
    border: 1px solid var(--color-button-secondary-text);
  }

  legend {
    margin: var(--spacing-8);
    box-shadow: none;
  }

  label {
    margin: var(--spacing-16) 0;
    font-size: var(--font-size-m);
  }

  textarea {
    color: var(--color-text);
    background-color: var(--color-bg);
  }

  .emojiwrapper {
    margin: var(--spacing-24) 0;
    display: flex;
    justify-content: center;
    border: none;
  }
</style>
